import type { auth } from "@/lib/auth/auth";
import {
    customSessionClient,
    usernameClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
    baseURL: process.env.NEXT_PUBLIC_BETTER_AUTH_URL,
    plugins: [usernameClient(), customSessionClient<typeof auth>()],
});

export const { useSession } = authClient;
